import BookPic from './BookPic.jsx';
import './styles/Book.scss';
import slideOne from '../svg/slide-one.png';
import slideTwo from '../svg/slide-two.png';
import slideThree from '../svg/slide-three.png';
import slideFour from '../svg/slide-four.png';
import arrowScroll from '../svg/arrow-scroll.svg';
import arrowScrollTwo from '../svg/arrow-scroll-two.svg';

import { useEffect, useState, useRef } from "react";

const library = [
    ['one', ['Liquidity ', <span>Positions </span>]],
    ['two', ['Synthetic ', <span>Assets </span>]],
    ['three', ['Digital ', <span>Art </span>]],
    ['four', ['Virtual ', <span>Land </span>]]
];

function Book() {   
    const timeoutRef = useRef(null);

    const [index, setIndex] = useState(0);
  
    function resetTimeout() {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };

    function prev() {
        setIndex((prevIndex) =>
            prevIndex === 0 ? 3 : prevIndex - 1
        )
        resetAnimation();
    }

    function next() {
        setIndex((prevIndex) =>
            prevIndex === 3 ? 0 : prevIndex + 1
        )
        resetAnimation();
    }

    function resetAnimation() {
        var el = document.getElementById('barAnimation');
        el.style.animation = 'none';
        setTimeout(() => {
            el.style.animation = '';
        }, 0) 
    }
  
    useEffect(() => {
      resetTimeout();
      timeoutRef.current = setTimeout(
        () =>
          setIndex((prevIndex) =>
            prevIndex === 3 ? 0 : prevIndex + 1
          ),
          5000
      );
      var test = library[index][0];
      return () => {
        resetTimeout();
      };
    }, [index]);
    

    return (
        <section className="book">
            <div className="bookContainer">
                <div className="bookText">
                    <h2 className="titleH2 upText">Faster than anyone imagined</h2>
                    <p className="desc2">
                        DeFi is consuming the traditional investment landscape and
                        bringing new utility to areas that have remained unchanged for
                        decades.
                    </p>
                </div>
                <div className="slideShow">
                    <div className="slideShowContainer">
                        <BookPic src={slideOne} staticName='one' name={library[index][0]}>{library[index][1]}</BookPic>
                        <BookPic src={slideTwo} staticName='two' name={library[index][0]}>{library[index][1]}</BookPic>
                        <BookPic src={slideThree} staticName='three' name={library[index][0]}>{library[index][1]}</BookPic>
                        <BookPic src={slideFour} staticName='four' name={library[index][0]}>{library[index][1]}</BookPic>
                        <div className="pointerCircle prev slickPrev slickArrow" onClick={prev}>
                            <div className="pointerCircleCore">
                                <img src={arrowScroll} alt="ArrowScroll"/>
                                <img src={arrowScrollTwo}/>
                            </div>
                        </div>
                        <div className="pointerCircle next slickNext slickArrow" onClick={next}>
                            <div className="pointerCircleCore">
                                <img src={arrowScroll} alt="ArrowScroll"/>
                                <img src={arrowScrollTwo}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
            
export default Book;
























{/* <div class="opening-text-scroll-circle next slick-next slick-arrow">
    <div class="opening-text-scroll-circle-core">
        <img src="img/arrow-scroll.svg" alt="Arrow-scroll">
        <img src="img/arrow-scroll-two.svg">
    </div>
</div>
<ul class="slick-dots" role="tablist">
    <li class="" role="presentation">
        <button type="button" role="tab" id="slick-slide-control00" aria-controls="slick-slide00" aria-label="1 of 4" tabindex="-1">
            1
        </button>
    </li>
    <li class="slick-active" role="presentation">
        <button type="button" role="tab" id="slick-slide-control01" aria-controls="slick-slide01" aria-label="2 of 4" tabindex="0" aria-selected="true">
            2
        </button>
    </li>
    <li class="" role="presentation">
        <button type="button" role="tab" id="slick-slide-control02" aria-controls="slick-slide02" aria-label="3 of 4" tabindex="-1">
            3
        </button>
    </li>
    <li role="presentation" class="">
        <button type="button" role="tab" id="slick-slide-control03" aria-controls="slick-slide03" aria-label="4 of 4" tabindex="-1">
            4
        </button>
    </li>
</ul> */}